import type { GitSyncEvent } from "@memes/shared";

/** Human-readable line for a git backup SSE event. */
export function formatGitSyncEvent(ev: GitSyncEvent): string {
  switch (ev.type) {
    case "start":
      return "Starting sync…";
    case "clone":
      return "Cloning backup repository (first run)…";
    case "pull":
      return "Fetching latest changes from remote…";
    case "push":
      return "Pushing library to backup repository…";
    case "scan":
      return "Scanning and reconciling…";
    case "added":
      return `+ ${ev.owner} / ${ev.filename}`;
    case "updated":
      return `↻ ${ev.owner} / ${ev.filename} (restored from backup)`;
    case "removed":
      return `− ${ev.owner} / ${ev.filename} (removed from backup)`;
    case "committed":
      return `Committed: ${ev.message}`;
    case "noop":
      return "Already in sync — no changes needed";
    case "complete":
      return `Complete — restored ${ev.restored}, added ${ev.added}, pushed ${ev.pushed}, removed ${ev.removed}`;
    case "error":
      return `Error: ${ev.message}`;
    default:
      return "Unknown event";
  }
}

export function gitSyncPhaseLabel(ev: GitSyncEvent): string {
  switch (ev.type) {
    case "start":
      return "Preparing…";
    case "clone":
      return "Cloning backup repo…";
    case "pull":
      return "Checking remote backup…";
    case "push":
      return "Backing up to git…";
    case "scan":
      return "Reconciling library…";
    case "added":
      return "Restoring tracks…";
    case "updated":
      return "Updating changed tracks…";
    case "removed":
      return "Cleaning backup repo…";
    case "committed":
      return "Committing backup…";
    case "noop":
      return "Up to date";
    case "complete":
      return "Finished";
    case "error":
      return "Failed";
    default:
      return "Working…";
  }
}
